import React, {Component} from "react";
import "../SliderQuotationContent.css";
import {Link} from 'react-router-dom';
import {FormattedMessage} from "react-intl";
import {BASE_URL} from "../../../../../../configuration";

class SliderQuotationContent2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quotation: {
                orderType: 3,
                fileKey: "",
                pcbParam: {
                    materialDetails: 0,
                    panelFlag: 0,
                    edgeRails : 0,
                    layer: 2,
                    length: 100,
                    width: 100,
                    qty: 5,
                    thickness: 1.6,
                    impedance: 1,
                    pcbColor: 0,
                    surfaceFinish: 0,
                    copperWeight: 1,
                    goldFinger: 0,
                    panelByJLCPCB_X: 0,
                    panelByJLCPCB_Y: 0,
                    differentDesign: 1,
                    flyingProbe : 1,
                    castellatedHoles : 0,
                    silkColor : 1,
                    orderDetailsRemark: ""
                },
                smtStencilParam: {
                    dimensionsID: 112,
                    stencilQty: 1,
                    electropolishing: 0,
                    fiducials: 0,
                    customizeFlag: 0,
                    customizeSizeX: 0,
                    customizeSizeY: 0,
                    customizeSize: 0,
                    stencilSide: 0,
                    orderRemark: "",
                    framework: 0
                }
            },
            qty : 1

        };

        this.setStencilParamOnChange = this.setStencilParamOnChange.bind(this);
        this.toStencilImageQuotation = this.toStencilImageQuotation.bind(this);
        this.setStencilDimensions = this.setStencilDimensions.bind(this);
    }
    setStencilDimensions = (event) => {
        let quotation = {...this.state.quotation};
        quotation.smtStencilParam[event.target.name] = event.target.value;
        this.setState({
            quotation
        })
    };

    setStencilParamOnChange = (event) => {

        let val = event.target.value;

        let　rex = /[\uFF10-\uFF19]/g;

        val = val.replace(rex, function (ch) {
            return String.fromCharCode(ch.charCodeAt(0) - 65248);
        });

        val = val.replace(/\s/g, '');
        val = val.replace(/\u3002/g, ".");

        if(val === ''){
            this.setState({
                qty : ''
            });

            return;
        }

        let quotation = {...this.state.quotation};
        let reg = new RegExp('^[0-9]+$');
        if (!reg.test(val)) {
            event.target.value = "";
            event.target.placeholder = event.target.name;
            return;
        }

        quotation.smtStencilParam[event.target.name] = parseFloat(val);

        this.setState({
            qty : val,
            quotation
        });
    };

    toStencilImageQuotation = (event) => {

        localStorage.setItem("type", 3);
        localStorage.setItem("type3q", JSON.stringify(this.state.quotation));

        // window.open(BASE_URL+'quotation/stencil', '');

    };

    render() {
        return (
            <div className="row">
                <div className="text-center">
                    <label className="img-slider-form-title">
                        <FormattedMessage id="app.image-slider.quotation.centent2-heading"
                                          defaultMessage="First, try the estimate"
                                          description=""/>
                    </label>
                </div>
                <div className="text-center">
                    <p className="quotation-content-caption caption-content-2">
                        {/*<FormattedMessage id="app.image-slider.quotation.centent2-description"*/}
                        {/*defaultMessage="You can easily estimate board manufacturing costs simply by entering the board size."*/}
                        {/*description=""/>*/}
                        <p className="font-size-13">希望のメタルマスクサイズを選択するだけで
                        </p>
                        <p className="font-size-13">簡単にメタルマスク製造費用をお見積りできます。
                        </p>

                    </p>
                </div>
                <div className="col-md-12 text-center table-div">
                    <table className="content2-table">
                        <tbody>
                        <tr>
                            <td>
                                <div className="input-div2 text-left">
                                    <FormattedMessage id="app.image-slider.quotation.centent2-size"
                                                      defaultMessage="Size"
                                                      description=""/>
                                    <label className="custom-select custom-select-content-2 stencil-select select-content-2">
                                        <select onChange={this.setStencilDimensions} name="dimensionsID"
                                                className="stencil-number-input-select">
                                            <option value={112}>380×280（有効エリア290×190mm)</option>
                                            <option value={501}>420×320（有効エリア400×240mm)</option>
                                            <option value={502}>450×350（有効エリア420×270mm)</option>
                                            <option value={503}>520×420（有効エリア490×340mm)</option>
                                            <option value={504}>460×460（有効エリア430×380mm)</option>
                                        </select>
                                    </label>
                                </div>
                            </td>
                            <td>
                                <div className="input-div2 text-left qty-div-margin">
                                    <div className="move-top-left">
                                        <FormattedMessage id="app.image-slider.quotation.centent2-quantity"
                                                          defaultMessage="Quantity"
                                                          description=""/>
                                    </div>

                                    {/*<label className="custom-select">*/}
                                    {/*<select>*/}
                                    {/*<option>Param1</option>*/}
                                    {/*</select>*/}
                                    <input name="stencilQty" onChange={this.setStencilParamOnChange}
                                           type="text" className="stencil-number-input" value={this.state.qty}/>
                                    {/*</label>*/}
                                </div>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                    <div className="btn-div-wrap">
                        <div className="btn-left-div"></div>
                        <Link to='quotation/stencil'>
                        <a onClick={this.toStencilImageQuotation}>
                            <button className="btn btn-div font-color-click-change" disabled={this.state.qty === '' || this.state.qty === '0'}>
                                <FormattedMessage id="app.image-slider.quotation.centent2-estimate"
                                                  defaultMessage="Estimate Start"
                                                  description=""/>&nbsp;
                                <i className="glyphicon glyphicon-circle-arrow-right icon-margin"></i>
                            </button>
                        </a>
                        </Link>

                        <div className="btn-right-div"></div>
                    </div>
                </div>
            </div>
        );
    }

}

export default SliderQuotationContent2;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/ImageSlider/ImageSliderQuotation/SliderQuotationContent2/SliderQuotationContent2.js